import { useEffect, useState } from 'react'
import type { CountryIso2 } from 'src/shared/components/phone-input'
import { getVisitorCountryWithTimeout } from 'src/shared/utils/visitor-country'

export const useVisitorCountryFallback = (
  enabled: boolean,
): CountryIso2 | null | undefined => {
  const [visitorCountry, setVisitorCountry] = useState<CountryIso2 | null>()

  useEffect(() => {
    if (!enabled) {
      setVisitorCountry(null)
      return
    }

    let mounted = true

    const setFallbackCountry = async () => {
      const country = await getVisitorCountryWithTimeout()

      if (mounted) {
        setVisitorCountry(country)
      }
    }

    setFallbackCountry()

    return () => {
      mounted = false
    }
  }, [enabled])

  return visitorCountry
}
